import { HeaderContainer, TitleContainer } from "../fall-analysis/style";
import { BigBoldText, useAnalyticsWrapper } from "../fall-analysis/form/sharedImports";
import { modifyTitle } from "../../../../utils/helpers/analyticsUtils";
import DropdownModal from "../../../../components/DropdownModal/DropdownModal";
import { IoMdClose } from "react-icons/io";
import CaregiverAuditForm from "./form/CaregiverAuditForm";
import { useCaregiverAuditForm } from "./useCaregiverAuditForm";

type CaregiverAuditFilterModalProps = {
  open: boolean;
  closeFn: () => void;
};

// On-screen "Modify" for the Caregiver Audit report (MARCC-773) — mirrors the Fall
// FilterModal pattern: pre-populate the same form with the report's current params,
// and on submit just close (the report's own queries pick up the new store values).
const CaregiverAuditFilterModal = ({
  open,
  closeFn,
}: CaregiverAuditFilterModalProps) => {
  const {
    caregiverAuditFacility,
    startDate,
    endDate,
    caregiverAuditIncidentTypes,
    caregiverAuditCaregiverIds,
  } = useAnalyticsWrapper((state) => ({
    caregiverAuditFacility: state.caregiverAuditFacility,
    startDate: state.startDate,
    endDate: state.endDate,
    caregiverAuditIncidentTypes: state.caregiverAuditIncidentTypes,
    caregiverAuditCaregiverIds: state.caregiverAuditCaregiverIds,
  }));

  const {
    facilityOptions,
    isFetching,
    setFieldValue,
    handleSubmit,
    values,
    isSubmitDisabled,
    incidentTypeOptions,
    onIncidentTypeChange,
    caregiverOptions,
    caregiversLoading,
    onCaregiverChange,
  } = useCaregiverAuditForm({
    submitFn: closeFn,
    initialFacility: caregiverAuditFacility,
    initialStartDate: startDate,
    initialEndDate: endDate,
    initialIncidentTypeLabels: caregiverAuditIncidentTypes,
    initialCaregiverIds: caregiverAuditCaregiverIds,
  });

  return (
    <DropdownModal isOpen={open}>
      <HeaderContainer className="mb-7">
        <TitleContainer>
          <BigBoldText style={{ color: "#b580ff" }}>
            Update Query - {modifyTitle("caregiver-audit")}
          </BigBoldText>
        </TitleContainer>
        <IoMdClose
          onClick={() => closeFn()}
          style={{ color: "#b580ff" }}
          className="cursor-pointer border-0 bg-purple-100 bg-transparent text-2xl font-medium"
        />
      </HeaderContainer>

      <CaregiverAuditForm
        formName="caregiverAuditFilterForm"
        handleSubmit={handleSubmit}
        facilityOptions={facilityOptions}
        setFieldValue={setFieldValue}
        values={values}
        closeFn={closeFn}
        isSubmitDisabled={isSubmitDisabled}
        isFetching={isFetching}
        bottom={true}
        incidentTypeOptions={incidentTypeOptions}
        onIncidentTypeChange={onIncidentTypeChange}
        caregiverOptions={caregiverOptions}
        caregiversLoading={caregiversLoading}
        onCaregiverChange={onCaregiverChange}
      />
    </DropdownModal>
  );
};

export default CaregiverAuditFilterModal;
